import { render, staticRenderFns } from "./bj.vue?vue&type=template&id=2d58ce9e&scoped=true&"
import script from "./bj.vue?vue&type=script&lang=js&"
export * from "./bj.vue?vue&type=script&lang=js&"
import style0 from "./bj.vue?vue&type=style&index=0&id=2d58ce9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d58ce9e",
  null
  
)

component.options.__file = "bj.vue"
export default component.exports